import { render, staticRenderFns } from "./PublicCourseList.vue?vue&type=template&id=2ddcd00f&scoped=true"
import script from "./PublicCourseList.vue?vue&type=script&lang=js"
export * from "./PublicCourseList.vue?vue&type=script&lang=js"
import style0 from "./PublicCourseList.vue?vue&type=style&index=0&id=2ddcd00f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcd00f",
  null
  
)

export default component.exports